import { fromJS } from 'immutable';

import * as types from './constants';
import { USER_TYPE, VIEW_MODE } from 'constants/common';

const initState = fromJS({
  filters: {
    skip: 0,
    take: 10,
    page: 1,
    view: VIEW_MODE.LIST,
    sortByNewest: true,
    terms: '',
    type: USER_TYPE.PORTAL,
    status: 'Running',
  },
});

export default (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.UPDATE_FILTERS: {
      return state.set('filters', fromJS(payload));
    }
    default:
      return state;
  }
};
